<template>
    <!-- Start Main Banner -->
    <div class="main-banner">
        <div class="d-table">
            <div class="d-table-cell">
                <div class="container">
                    <div class="row h-100 justify-content-center align-items-center">
                        <div class="col-lg-5">
                            <div class="hero-content">
                                <h1>Wohuu! Du bist unser Early Adopter</h1>
                                <p>Nachhaltigkeit ist für dich wichtig - genauso wie für uns. Nehme jetzt an unserem Beta-Tester Programm teil und erhalte exklusiven Zugang zu Vorteilen. Jedes mal wenn du dich nachhaltig fortbewegst.</p>
                                
                                <!--<a href="#" class="btn btn-primary">Get Started</a>-->
                            </div>
                        </div>

                        <div class="col-lg-5 offset-lg-1">
                            <div class="banner-form ml-3" id="app">
                                <form prefix="formElement" ref="form">
                                    
                                    <div class="form-group">
                                        <label>Dein Name</label>
                                        <input type="text" class="form-control" placeholder="Enter your name" v-model="name" required>
                                    </div>

                                    <div class="form-group">
                                        <label>Deine Email</label>
                                        <input type="email" class="form-control" placeholder="Enter your email" v-model="email" required>
                                    </div>

                                                    <!--<div class="form-group">
                                    <label>Password</label>
                                    <input type="password" class="form-control" placeholder="Create a password">
                                    </div>-->

                                    <button type="button" v-on:click="response" class="btn btn-primary">Get started</button>
                                </form>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>

        <div class="shape1"><img src="../../../assets/img/shape1.png" alt="shape"></div>
        <div class="shape2 rotateme"><img src="../../../assets/img/shape2.svg" alt="shape"></div>
        <div class="shape3"><img src="../../../assets/img/shape3.svg" alt="shape"></div>
        <div class="shape4"><img src="../../../assets/img/shape4.svg" alt="shape"></div>
        <div class="shape5"><img src="../../../assets/img/shape5.png" alt="shape"></div>
        <div class="shape6 rotateme"><img src="../../../assets/img/shape4.svg" alt="shape"></div>
        <div class="shape7"><img src="../../../assets/img/shape4.svg" alt="shape"></div>
        <div class="shape8 rotateme"><img src="../../../assets/img/shape2.svg" alt="shape"></div>
    </div>
    <!-- End Main Banner -->
</template>

<script>
    import axios from 'axios';
    export default {
        name: 'Banner',
        data() {
            return {
                name: "", 
                email: "",
            };
        },
        methods: {
            response() {
                console.log("clicked");
                if (this.$refs.form.checkValidity() === false) {
                    alert("Check again, whether you've submitted your name and correct email address.");
                    return;
                }
                var url = 'https://educating-the-guess.com/sendData_1.php'
                axios.post(url, { name: this.name, email: this.email
                }).then( (response) => {
                    console.log(response)
                    this.$router.push({ name: "early-adopter" });

                }).catch(console.error);
            }
        },
    }
</script>